import React, { Component } from 'react'
import { Button, Alert } from 'hljd'
import VideoUpload from '@common/Hotel/VideoUpload'
import { observer } from 'mobx-react'
import { ALBUM_KIND } from '@components/Hotel/constant'

import upload from '@common/Upload/config'
import ImgCard from '../ImgCard'
import style from './style.module.less'
import Store from './store'
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'
import { APPROVAL_STATUS } from '@components/Hotel/constant'
const SortableItem = SortableElement(({ children }) => children)
const SortableList = SortableContainer(({ children }) => (
  <div className={style.sortContainer}>{children}</div>
))
// 说明文案
const UPLOAD_DESCRIPTION = {
  [ALBUM_KIND.OUTWARD]:
    '添加可表现酒店周遭环境的照片，包括酒店外观、酒店室外公共区域、花园、后院等（请勿放置宴会厅、场布照片等内容）',
  [ALBUM_KIND.HALL]:
    '添加可表现酒店内部公共环境的照片，如大厅、休闲区、待客区等（请勿放置宴会厅、场布照片等内容）',
  [ALBUM_KIND.CELEBRITY]:
    '添加本店热门拍照打卡处的照片，非必填。（请勿上传宴会厅或与外观环境一致的照片）',
  [ALBUM_KIND.VIDEO]:
    '建议视频尽量突出酒店特色，避免太多的局部镜头，画质清晰，色调明亮。',
  [ALBUM_KIND.MARRY_HOUSE]:
    '添加酒店可提供的新娘房的照片：如新娘房房间、客厅、卫浴等区域。',
  [ALBUM_KIND.GUEST_HOUSE]:
    '添加酒店可提供的客房的照片：如房间照片、客厅、卫浴等区域。',
  [ALBUM_KIND.SPECIAL_HOUSE]:
    '添加酒店可提供的特色场地照片：如屋顶花园、after party、KTV、茶吧、桌游、麻将室、画廊等区域。'
}

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(this.props.scene)
    this.imageUploadNode = 'album_image_upload' + Math.random().toFixed(8)
    this.imageContainerNode = 'album_image_box' + Math.random().toFixed(8)
  }

  componentDidMount() {
    this.imgUpload = upload({
      browse_button: this.imageUploadNode,
      container: this.imageContainerNode,
      drop_element: this.imageUploadNode,
      max_file_size: '15mb',
      // image_types: 'jpg,png,bmp,jpeg',
      multi_selection: true,
      filters: {
        mime_types: [
          {
            title: 'Image files',
            extensions: 'jpg,gif,png,jpeg,bmp'
          }
        ]
      },
      //上传后
      fileUploaded: this.store.imageUploaded,
      //上传失败
      onError: this.store.imageUploadError,
      beforeUpload: this.store.imageBeforeUpload
    })
    this.store.getAlbum()
  }

  renderImages = images => {
    return images.map((img, index) => (
      <ImgCard
        key={index}
        src={img.url}
        status={img.status}
        onDelete={() => this.store.handleImageDelete(images, index)}
      />
    ))
  }

  render() {
    const {
      images,
      video,
      modalVisible,
      loading,
      approvalText,
      sortImages,
      isUploading,
      sortEnd,
      triggerVideoModal,
      saveAlbum,
      clearInvalidImg,
      triggerSort,
      handleVideoOk,
      handleVideoDelete,
      handleVideoCancel,
      handleVideoError,
      scene
    } = this.store

    return (
      <div className={style.container}>
        {approvalText && (
          <Alert
            className={style.alert}
            message={approvalText}
            style={{ marginBottom: 10 }}
            type="warning"
            showIcon
          />
        )}

        <div className={style.center}>
          {scene === ALBUM_KIND.VIDEO && (
            <div style={{ marginBottom: 8 }}>
              <div className={style.title}>{UPLOAD_DESCRIPTION[scene]}</div>
              <div className={style.content}>
                <Button
                  className={style.btn}
                  onClick={triggerVideoModal}
                  disabled={video.length >= 10}
                >
                  上传视频
                </Button>

                <div className={style.photoArea}>
                  {video.length > 0 ? (
                    <div className={style.photos}>
                      {video.map((item, index) => {
                        return (
                          <ImgCard
                            key={index}
                            src={item.coverPath}
                            isVideo={true}
                            status={item.status}
                            onDelete={handleVideoDelete(index)}
                          />
                        )
                      })}
                    </div>
                  ) : (
                    <span> 上传的视频将用于主页相册展示 </span>
                  )}
                </div>

                <span className={style.tip}>
                  可上传10个视频，单个视频100M以内，建议视频宽高比16:9。
                </span>
              </div>
            </div>
          )}
          {scene !== ALBUM_KIND.VIDEO && (
            <div>
              <div className={style.title}>{UPLOAD_DESCRIPTION[scene]}</div>
              <div className={style.content}>
                <Button
                  className={style.btn}
                  style={{ marginRight: 8 }}
                  id={this.imageUploadNode}
                >
                  上传照片
                </Button>

                <Button
                  type="primary"
                  loading={loading.sort}
                  className={style.btn}
                  ghost
                  onClick={triggerSort}
                >
                  {sortImages.length === 0 ? '调整排序' : '完成'}
                </Button>

                <div className={style.photoArea} id={this.imageContainerNode}>
                  {images.invalid.length !== 0 && (
                    <div className={style['fix-top']}>
                      <p>发现有审核未通过的照片记录，是否一键清除？</p>
                      <a onClick={clearInvalidImg}>清除</a>
                    </div>
                  )}
                  {images.valid.length !== 0 || images.invalid.length !== 0 ? (
                    <div className={style.photos}>
                      {sortImages.length === 0 ? (
                        <>
                          {this.renderImages(images.invalid)}
                          {isUploading && (
                            <ImgCard
                              status={APPROVAL_STATUS.PASS}
                              isLoading={isUploading}
                            />
                          )}
                          {this.renderImages(images.valid)}
                        </>
                      ) : (
                        // 排序
                        <SortableList
                          onSortEnd={prop => sortEnd(arrayMove, prop)}
                          axis="xy"
                          hideSortableGhost={true}
                        >
                          {sortImages.map((img, index) => (
                            <SortableItem key={index} index={index}>
                              <ImgCard
                                key={index}
                                src={img.url}
                                status={img.status}
                              />
                            </SortableItem>
                          ))}
                        </SortableList>
                      )}
                    </div>
                  ) : (
                    <span> 上传的照片将用于主页相册展示 </span>
                  )}
                </div>

                <span className={style.tip}>
                  至多上传100
                  张照片，点击调整顺序按钮可改变图片排序（图片请勿添加水印，宽高比尽量接近4
                  : 3，单张图片不要超过15M，支持JPG、PNG等常见图片格式)
                </span>
              </div>
            </div>
          )}

          <footer>
            <Button type="primary" loading={loading.save} onClick={saveAlbum}>
              保存
            </Button>
          </footer>
        </div>

        <VideoUpload
          modal_visible={modalVisible}
          onVideoOk={handleVideoOk} // 模态框点击确定后的回调
          onVideoCancel={handleVideoCancel} // 模态框点击取消后的回调
          onVideoError={handleVideoError}
          video_types="flv,mp4,mkv,wmv,avi,mov,rm,rmvb,mpeg,m4v"
        />
      </div>
    )
  }
}
